module.exports = __webpack_public_path__ + "img/previo2.31cdbf77.png";